import styled from '@emotion/styled';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 4px;
`;
